import { __decorate } from "tslib";
import { Component, Mixins } from "vue-property-decorator";
// SYSTEM1
import Loader from "@/components/widgets/loader.vue";
import Layout from "@/router/layouts/main.vue";
import PageHeader from "@/components/page-header.vue";
import BaseMixer from "@/router/views/BaseMixer";
import { interpret } from "xstate";
import cycleMachine from "./machines/CyclesMachine";
import CycleInfoComponent from "./components/CycleInfo.vue";
import SelectResourceComponent from "./components/SelectResource.vue";
import SelectWorkflowComponent from "./components/SelectWorkflow.vue";
import LetsFinishComponent from "./components/LetsFinish.vue";
import { CycleModule } from "@/store/modules/cycle.module";
import { PACycleSaveModel } from "@/store/models/cycle/paCycleSaveDTO";
import { toaster } from "@/utilities/toaster";
import { DateFormatConstant } from "@/store/DateFormatConstants";
let CreateCycle = /** @class */ (() => {
    let CreateCycle = class CreateCycle extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            this.title = "Create New Cycle";
            this.ctaButtons = [{ routeName: "CycleListing" }];
            this.selectedStepTitle = "CYCLE INFO";
            this.paCycleSave = new PACycleSaveModel();
            this.period = "";
            this.items = [
                {
                    text: "Home",
                    to: "/dashBoard",
                },
                {
                    text: "Performance",
                    href: "#",
                },
                {
                    text: "Cycles",
                    to: "/performance/cycles",
                },
                {
                    text: "Add New Cycle",
                    active: true,
                },
            ];
            this.teamId = "";
            this.pageIsLoading = true;
            this.cycleTitlePeriod = {
                cycleName: "",
                period: "",
            };
            this.cycleSteps = [
                { title: "CYCLE INFO", completed: false },
                { title: "SELECT RESOURCE", completed: false },
                { title: "SELECT WORKFLOW", completed: false },
                { title: "CONFIRM", completed: false },
            ];
            this.machine = cycleMachine.withContext({
                teamId: null,
                paCycleSave: new PACycleSaveModel(),
            });
            this.machineService = interpret(this.machine, { devTools: true });
            this.state = this.machine.initialState;
        }
        goToNextStep() {
            this.pageIsLoading = true;
            this.SetCycleTitleAndPeriod();
            if (this.state.matches("cyclePrimaryInfo")) {
                this.validate("cycleInfoObserver").then((response) => {
                    if (response) {
                        CycleModule.CheckForDuplicateCycleName(this.paCycleSave.name).then((response) => {
                            if (!response.isDuplicate) {
                                if (this.checkForValidDates()) {
                                    this.machineService.send({ type: "NEXT_CYCLE_STEP", teamId: this.paCycleSave.pmoTeamId });
                                }
                                else {
                                    toaster.ShowError("Start date should not be greater than end date.");
                                }
                            }
                            else {
                                toaster.ShowError("A cycle with the same name already exists.");
                            }
                        });
                    }
                });
            }
            else {
                if (this.state.matches("loadedWorkFlows")) {
                    if (this.EmployeesWorFlow.length != 0) {
                        var reprotingToCheck = this.EmployeesWorFlow.some((x) => x.reportingTo == null);
                        var checkforEmployeesWorkflow = this.EmployeesWorFlow.some((x) => x.workFlowId == null);
                        if (!reprotingToCheck) {
                            if (!checkforEmployeesWorkflow) {
                                this.machineService.send({ type: "NEXT_CYCLE_STEP", teamId: this.paCycleSave.pmoTeamId });
                            }
                            else {
                                toaster.ShowError("Please select a workflow for all team members");
                            }
                        }
                        else {
                            toaster.ShowError("Please set a ReportingTo for the member to proceed");
                        }
                    }
                    else {
                        toaster.ShowError("Please have at least one team member to create a cycle.");
                    }
                }
                else {
                    this.machineService.send({ type: "NEXT_CYCLE_STEP", teamId: this.paCycleSave.pmoTeamId });
                }
            }
        }
        get IsCycleNameDuplicate() {
            return CycleModule.isDuplicateCycleName;
        }
        checkForValidDates() {
            if (this.dateFormat === DateFormatConstant.DateFormat.DateFormatMDY()) {
                this.paCycleSave.startDateAsString = this.dateFormattedString(this.paCycleSave.startDate);
                this.paCycleSave.endDateAsString = this.dateFormattedString(this.paCycleSave.endDate);
            }
            else {
                this.paCycleSave.startDateAsString = this.dateFormatted(this.paCycleSave.startDate);
                this.paCycleSave.endDateAsString = this.dateFormatted(this.paCycleSave.endDate);
            }
            if (this.paCycleSave.startDate > this.paCycleSave.endDate) {
                return false;
            }
            return true;
        }
        SetCycleTitleAndPeriod() {
            this.cycleTitlePeriod.cycleName = this.paCycleSave.name;
            this.period = this.dateRangeFormattedString(this.paCycleSave.startDate, this.paCycleSave.endDate);
            this.cycleTitlePeriod.period = this.period;
        }
        goToPrevStep() {
            if (!this.state.matches("loadedCofirmation")) {
            }
            this.machineService.send({ type: "PREV_CYCLE_STEP" });
            this.pageIsLoading = true;
        }
        goToCycleOverView(cycleId) {
            this.$router.push({ name: "CycleOverview", params: { cycleId: cycleId } });
        }
        backToList() {
            this.$router.push({ name: "CycleListing" });
        }
        cycleSuccessPopup() {
            this.machineService.send({ type: "CREATE_CYCLE", paCycleSave: this.paCycleSave });
        }
        get teamList() {
            return CycleModule.pMOteams;
        }
        get EmployeesWorFlow() {
            return CycleModule.employeesWorkFlow;
        }
        get ShowButton() {
            return !(this.state.matches("gettingTeams") ||
                this.state.matches("gettingWorkFlows") ||
                this.state.matches("gettingConfirmation") ||
                this.state.matches("creatingCycle") ||
                this.state.matches("cycleCreated"));
        }
        //   MACHINE
        created() {
            this.machineService.start();
            this.machineService.onTransition((state) => {
                this.state = state;
                console.log(state.toStrings());
                if (this.state.matches("cyclePrimaryInfo")) {
                    this.selectedStepTitle = "CYCLE INFO";
                }
                if (this.state.matches("teamsLoaded")) {
                    this.selectedStepTitle = "SELECT RESOURCE";
                    this.cycleSteps[0].completed = true;
                }
                if (this.state.matches("loadedWorkFlows")) {
                    this.selectedStepTitle = "SELECT WORKFLOW";
                    this.cycleSteps[1].completed = true;
                }
                if (this.state.matches("loadedCofirmation")) {
                    this.selectedStepTitle = "CONFIRM";
                    this.cycleSteps[2].completed = true;
                }
                if (this.state.matches("creatingCycle")) {
                    this.cycleSteps[3].completed = true;
                    this.$bvModal.show("Cycle-Success-Modal");
                }
                if (this.state.matches("gettingWorkFlows")) {
                    this.pageIsLoading = true;
                }
            });
        }
        destroyed() {
            this.machineService.stop();
        }
    };
    CreateCycle = __decorate([
        Component({
            name: "CreateCycle",
            components: {
                Layout,
                PageHeader,
                Loader,
                CycleInfoComponent,
                SelectResourceComponent,
                SelectWorkflowComponent,
                LetsFinishComponent,
            },
        })
    ], CreateCycle);
    return CreateCycle;
})();
export default CreateCycle;
